<app-popup-layout #modal>
  <div class="modal-container">
    <img
      (click)="closeDialog()"
      class="help-screen-close-button ms-auto me-3"
      src="/assets/svg/model-close-btn.svg"
      alt="close"
    />

    <p class="modal-title" id="modal-basic-title">How does it work?</p>

    <img src="assets/images/enach-workflow.png" alt="Enach WorkFlow" />
  </div>
</app-popup-layout>
